/**
 * From an array of accounts, finds one by "cipher.accountId" matched by a passed "accountId"
 *
 * @param accounts Array of Accounts to search through
 * @param accountId string to match an account's cipher.accountId with
 * @returns Account | undefined (if a accountId match is found)
 */
var findAccount = function (accounts, accountId) {
    return accounts === null || accounts === void 0 ? void 0 : accounts.find(function (account) { return account.info["cipher.accountId"] === accountId; });
};
export default findAccount;
//# sourceMappingURL=findAccount.js.map